import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { executionLogsAccountsSelector } from "./executionLogsAccountsSelector";
import { accountsGroupedByProviderCombiner } from "../../combiners/accountsGroupedByProviderCombiner";

export const executionLogsAccountsGroupedByProviderSelector =
  createDraftSafeSelector(
    [executionLogsAccountsSelector],
    accountsGroupedByProviderCombiner,
  );
